<script setup lang="ts">
defineProps<{ isOpened: boolean }>();
</script>

<template>
  <div class="flex size-16 flex-col items-center justify-center gap-2">
    <div class="tham tham-e-spin tham-w-10" :class="isOpened && 'tham-active'">
      <div class="tham-box">
        <div class="tham-inner bg-current" />
      </div>
    </div>
    <div class="text-sm leading-none">
      {{ isOpened ? 'Fermer' : 'Menu' }}
    </div>
  </div>
</template>
